module.exports = __webpack_public_path__ + "img/table-sort.292b8ad0.svg";